import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { editProfileBunja } from '../../../bunja';
import { Input } from '../../input';

export const Username = () => {
  const { usernameAtom, usernameValidationAtom } = useBunja(editProfileBunja);
  const [username, setUsername] = useAtom(usernameAtom);
  const usernameValidation = useAtomValue(usernameValidationAtom);
  return (
    <div className={stack({ gap: 12 })}>
      <label htmlFor='username' className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Username' />
      </label>
      <Input
        value={username}
        onChange={(e) => setUsername(e.currentTarget.value)}
        onXClick={username ? () => setUsername('') : undefined}
        message={'Create a username between 3 and 17 characters.\nYou can change it once every 30 days.'}
        error={usernameValidation.message}
      />
    </div>
  );
};
